import React, { ReactElement, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { PrivateRoute, ValidateToken } from 'app/routes';

import { NavbarTypes, MainNavbar, ContentNavbar } from 'features/navbar';
import Footer from 'features/footer';
import { ChatBot, Flex, Whatsapp } from 'components';
import Menu, { Menu2 } from 'features/menu';
import { useSheets } from 'features/dashboard-new';
import { useSchool } from 'features/school';
import { useBreakpoints } from 'app/hooks';

interface MainLayoutProps {
  navbar?: NavbarTypes;
  withoutSearchButton?: boolean;
}

const MainLayout = ({ navbar = 'main', withoutSearchButton }: MainLayoutProps): ReactElement => {
  const { schoolAlias } = useSchool();

  const { usingDashboard, getDashboardUi } = useSheets();

  const breakpoint = useBreakpoints();

  let Navbar = MainNavbar;

  switch (navbar) {
    case 'content':
      Navbar = ContentNavbar;
      break;

    case 'main':
    default:
      Navbar = MainNavbar;
      break;
  }

  useEffect(() => {
    getDashboardUi();
  }, []);

  return (
    <ValidateToken>
      <PrivateRoute>
        <Whatsapp />
        <ChatBot />

        <Flex
          className={`theme-${schoolAlias} theme-wrapper theme-wrapper-${breakpoint}`}
          flexWrap="inherit"
          minHeight="100vh"
          flexDirection="column"
        >
          <Flex flexGrow={0}>
            {usingDashboard ? <Menu2 /> : <Menu />}
            <Navbar withoutSearchButton={withoutSearchButton} />
          </Flex>

          <Flex as="main" role="main" flexWrap="nowrap" flexDirection="column">
            <Outlet />
          </Flex>

          <Flex flexGrow={0}>
            <Footer />
          </Flex>
        </Flex>
      </PrivateRoute>
    </ValidateToken>
  );
};

export default MainLayout;
